import axios from 'axios'

export default {
    namespaced: true,
    state: {
        beautySalons: []
    },
    mutations: {
        FETCH_SALON(state, salon) {
            state.beautySalons = salon
        },
        ADD_SALON(state, salon) {
            state.beautySalons.push(salon)
        },
        EDIT_SALON(state, salon) {
            const index = state.beautySalons.findIndex(
                item => item.id === salon.id
            )
            if (index !== -1) {
                Object.assign(state.beautySalons[index], salon)
            }
        },
        DEL_SALON(state, salon) {
            const index = state.beautySalons.findIndex(
                item => item.id === salon.id
            )
            if (index !== -1) {
                state.beautySalons.splice(index, 1)
            }
        }
    },
    actions: {
        fetch({commit, dispatch, state}, isPreload = true) {
            if (!state.beautySalons.length) {
                if (isPreload) {
                    commit('TOGGLE_PRELOADER', true, {root: true})
                }
                return axios.get(
                    '/api/root/beauty-salons/list'
                ).then(({data}) => {
                    commit('FETCH_SALON', data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                }).finally(() => {
                    if (isPreload) {
                        commit('TOGGLE_PRELOADER', false, {root: true})
                    }
                })
            }
        },
        add({commit, dispatch}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/beauty-salons/add',
                    prepareData(data)
                ).then(({data}) => {
                    commit('ADD_SALON', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/beauty-salons/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    commit('EDIT_SALON', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({commit, dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/beauty-salons/dell/' + itemId
                ).then(({data}) => {
                    commit('DEL_SALON', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

function prepareData (data) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('name', data.name)
    fd.append('intro', data.intro)
    fd.append('description', data.description)

    return fd
}
